import { uiState } from '../data'
import { useSnapshot } from 'valtio'
import { useEffect, useRef } from 'react'
import { isMobile } from 'react-device-detect'
import { motion, AnimatePresence } from 'framer-motion'

const MouseStyle = ({ event }) => {
  const {
    style,
    positionX,
    positionY,
    isMouseInside,
    isMapHover,
    showOrangeSpot
  } = useSnapshot(uiState[event])
  const rafId = useRef(null) // 用來存儲 requestAnimationFrame 的 ID
  const circle1Ref = useRef(null)
  const circle2Ref = useRef(null)

  const handleMouseMove = (e) => {
    uiState[event].positionX = e.clientX
    uiState[event].positionY = e.clientY
  }

  const handleMouseEnter = () => {
    uiState[event].isMouseInside = true
    requestAnimationFrame(updateMouse)
  }

  const handleMouseLeave = () => {
    uiState[event].isMouseInside = false
    cancelAnimationFrame(rafId.current)
  }

  const handleMouseDown = () => {
    uiState[event].style = 'down'
  }

  const handleMouseUp = () => {
    uiState[event].style = 'default'
  }

  const updateMouse = () => {
    // 获取最新的 style 和 positionX
    const currentStyle = uiState[event].style
    const currentPositionX = uiState[event].positionX
    const currentPositionY = uiState[event].positionY

    const circle1X = currentPositionX - 5
    const circle1Y = currentPositionY - 5

    // 更新第一个圆圈的位置和大小
    if (circle1Ref.current) {
      circle1Ref.current.style.transform = `translate(${circle1X}px, ${circle1Y}px)`
    }

    // 逐渐减小第二个圆圈的位置更新量

    const circle2Size = 65
    const circle2X = currentPositionX - circle2Size * 0.5
    const circle2Y = currentPositionY - circle2Size * 0.5

    const previousCircle2Transform =
      (circle2Ref.current && circle2Ref.current.style.transform) ||
      `translate(${circle2X}px, ${circle2Y}px)`
    const previousCircle2X = parseFloat(
      previousCircle2Transform.split('(')[1].split('px')[0]
    )
    const previousCircle2Y = parseFloat(
      previousCircle2Transform.split(' ')[1].split('px')[0]
    )

    // 逐渐减小移动速度
    const deltaX = (circle2X - previousCircle2X) * 0.25 // 调整此值以控制速度
    const deltaY = (circle2Y - previousCircle2Y) * 0.25 // 调整此值以控制速度

    // 更新第二个圆圈的位置和大小
    if (circle2Ref.current) {
      if (style === 'default') {
        circle2Ref.current.style.transform = `translate(${
          previousCircle2X + deltaX
        }px, ${previousCircle2Y + deltaY}px)`
      } else {
        circle2Ref.current.style.transform = `translate(${circle2X}px, ${circle2Y}px)`
      }

      circle2Ref.current.style.width = `${circle2Size}px`
    }

    rafId.current = requestAnimationFrame(updateMouse)
  }

  useEffect(() => {
    rafId.current = requestAnimationFrame(updateMouse)

    return () => {
      cancelAnimationFrame(rafId.current)
    }
  }, [])

  useEffect(() => {
    window.addEventListener('mousemove', handleMouseMove)
    document.addEventListener('mouseenter', handleMouseEnter)
    document.addEventListener('mouseleave', handleMouseLeave)
    window.addEventListener('mousedown', handleMouseDown)
    window.addEventListener('mouseup', handleMouseUp)

    return () => {
      window.removeEventListener('mousemove', handleMouseMove)
      document.removeEventListener('mouseenter', handleMouseEnter)
      document.removeEventListener('mouseleave', handleMouseLeave)
      window.removeEventListener('mousedown', handleMouseDown)
      window.removeEventListener('mouseup', handleMouseUp)
      cancelAnimationFrame(rafId.current)
    }
  }, [])

  return (
    <div className='screen-setting fixed top-0 left-0 z-[99] pointer-events-none'>
      {isMouseInside && !isMobile && (
        <>
          <div
            ref={circle1Ref}
            className={` absolute top-0 left-0 w-[10px] aspect-square  rounded-[50%]  `}
          >
            <AnimatePresence>
              {showOrangeSpot && (
                <motion.div
                  className={`absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full aspect-square rounded-[50%] ${
                    !showOrangeSpot
                      ? 'bg-transparent'
                      : isMapHover
                      ? 'backdrop-invert-[100%] '
                      : ' bg-mainOrange-100'
                  }  `}
                  initial={{ scale: 0, x: '-50%', y: '-50%' }}
                  animate={{ scale: 1, x: '-50%', y: '-50%' }}
                  exit={{ scale: 0 }}
                ></motion.div>
              )}
            </AnimatePresence>
          </div>

          <div
            ref={circle2Ref}
            className=' absolute top-0 left-0 aspect-square rounded-[50%]'
          >
            <motion.div
              className=' absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 border-[2px] border-white w-full aspect-square rounded-[50%]'
              initial={{ width: '100%' }}
              animate={{ width: style === 'default' ? '100%' : '70%' }}
              transition={{ duration: 0.2 }}
            ></motion.div>
          </div>
        </>
      )}
    </div>
  )
}

export default MouseStyle
